import { Phone, Mail, MapPin, Clock, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const ITEMS = [
  { icon: Phone, label: "Call us", value: "+91 79810 75618", href: "tel:+917981075618", id: "contact-phone-1" },
  { icon: Phone, label: "Call us", value: "+91 91775 64249", href: "tel:+919177564249", id: "contact-phone-2" },
  { icon: Mail, label: "Email", value: "connect@wingsoffirefoundation.org", href: "mailto:connect@wingsoffirefoundation.org", id: "contact-email-link" },
  { icon: MapPin, label: "Office", value: "Hyderabad, Telangana 500038", id: "contact-address-box" },
  { icon: Clock, label: "Office hours", value: "Mon – Fri · 9:00 AM – 5:00 PM", id: "contact-hours-box" },
];

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="relative bg-[#F3EADF] py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-5">
        <Eyebrow testId="contact-eyebrow">Contact & Connect</Eyebrow>
        <Reveal>
          <h2 className="font-serif text-5xl sm:text-6xl text-[#0F1D2F] mt-6 leading-[0.95] tracking-tight">
            Send us <em className="text-fire">love.</em>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 text-base sm:text-lg text-[#2B3A4A] leading-relaxed">
            Contact us to learn how to volunteer, donate, or partner with us, as well as to find out more about how we can provide trainings and workshops.
          </p>
          <a href="mailto:connect@wingsoffirefoundation.org" data-testid="contact-page-button" className="btn-dark mt-10">
            Email us <ArrowUpRight className="w-4 h-4" />
          </a>
        </Reveal>
      </div>
      <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
        {ITEMS.map((it, i) => {
          const Icon = it.icon;
          const Tag = it.href ? "a" : "div";
          return (
            <Reveal key={it.id} delay={i * 0.06} className={i === 2 ? "sm:col-span-2" : ""}>
              <Tag
                href={it.href}
                data-testid={it.id}
                className="group flex items-center gap-5 rounded-[24px] bg-white/80 border border-[#0F1D2F]/10 p-6 hover:border-[#CF5C0F] transition-colors h-full"
              >
                <span className="w-12 h-12 shrink-0 rounded-full bg-[#0F1D2F] text-[#F2B36B] flex items-center justify-center group-hover:bg-[#CF5C0F] group-hover:text-white transition-colors">
                  <Icon className="w-5 h-5" />
                </span>
                <span className="min-w-0">
                  <span className="block font-mono text-xs tracking-[0.2em] uppercase text-[#8A4B22]">{it.label}</span>
                  <span className="block text-[#0F1D2F] font-semibold text-base sm:text-lg break-words">{it.value}</span>
                </span>
              </Tag>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
